import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { touchWebClient } from 'tradera/utils/http';
import * as itemActions from 'tradera/state/items/actions';
import { logger } from 'packages/logger';

const MAX_FETCH_NUM_ITEMS = 50;

export const useFetchWishList = (filter) => {
    const dispatch = useDispatch();

    const [wishListItemsData, setWishListItemsData] = useState({
        items: [],
        totalCount: 0
    });
    const [query, setQuery] = useState({
        filter: null,
        page: 1,
        itemsPerPage: MAX_FETCH_NUM_ITEMS
    });
    const [isFetching, setIsFetching] = useState(false);

    const fetchNextPage = useCallback(() => {
        setQuery((state) => ({ ...state, page: state.page + 1 }));
    }, []);

    useEffect(() => {
        setQuery({
            filter,
            page: 1,
            itemsPerPage: MAX_FETCH_NUM_ITEMS
        });
    }, [filter]);

    useEffect(() => {
        const { filter, page, itemsPerPage } = query;
        if (!filter) return;

        setIsFetching(true);

        const getWishListItems = async () => {
            try {
                const { data } = await touchWebClient.get(
                    `/my/api/wish-list?page=${page}&filter=${filter}&itemsPerPage=${itemsPerPage}`
                );

                const itemIds = data.items.map((item) => item.itemId);
                dispatch(itemActions.addItemsToWishList(itemIds));

                if (page > 1) {
                    setWishListItemsData((state) => ({
                        items: [...state.items, ...data.items],
                        totalCount: data.totalCount
                    }));
                } else {
                    setWishListItemsData({
                        items: data.items,
                        totalCount: data.totalCount
                    });
                }
            } catch (error) {
                logger(`Fetch wish list failed ${error}`);
            } finally {
                setIsFetching(false);
            }
        };

        getWishListItems();
    }, [dispatch, query]);

    return {
        wishListItems: wishListItemsData.items,
        totalCount: wishListItemsData.totalCount,
        isFetching,
        page: query.page,
        fetchNextPage
    };
};
